import { Link } from "react-router";
import { BackButton } from "../../components/BackButton";

const ROUTES = [
  {
    title: "Joined with a phone number?",
    blurb: "Accounts from the old app need an email to sign in. Add yours here.",
    to: "/claim-email",
  },
  {
    title: "School admin",
    blurb: "Manage your school's students and see class results.",
    to: "/school",
  },
  {
    title: "Parent or guardian",
    blurb: "Parents don't need an account — everything you need is in the link we texted you.",
    to: null,
  },
  { title: "PrepAI staff", blurb: "Internal admin console.", to: "/staff" },
];

/**
 * Screen 21 — and the parent row is a deliberate dead end.
 *
 * There is no parent login because there is no parent account: consent and
 * progress both arrive by SMS link. Saying so here stops a parent hunting for
 * a password that was never issued.
 */
export function OtherLoginsScreen() {
  return (
    <div className="app-column px-5 pb-6 pt-6">
      <BackButton to="/login" />

      <h1 className="m-0 pt-4 font-[family-name:var(--font-display)] text-[22px] font-bold">
        Other ways to sign in
      </h1>
      <p className="m-0 pt-2 text-[13px] text-text-muted">
        Students sign in with email and password on the previous screen.
      </p>

      <ul className="m-0 flex list-none flex-col gap-2.5 p-0 pt-6">
        {ROUTES.map((route) => {
          const body = (
            <>
              <span className="text-[14.5px] font-semibold">{route.title}</span>
              <span className="text-[12.5px] leading-[1.45] text-text-muted">{route.blurb}</span>
            </>
          );

          return (
            <li key={route.title}>
              {route.to ? (
                <Link
                  to={route.to}
                  className="flex flex-col gap-1 rounded-[var(--radius-card)] border border-border bg-surface p-4"
                >
                  {body}
                </Link>
              ) : (
                <div className="flex flex-col gap-1 rounded-[var(--radius-card)] border border-border bg-surface p-4 opacity-70">
                  {body}
                </div>
              )}
            </li>
          );
        })}
      </ul>

      <p className="m-0 pt-6 text-[12.5px] leading-[1.5] text-text-muted">
        Lost your parent link? Ask your child to resend it from their Profile.
      </p>
    </div>
  );
}
